import React from 'react';

const MLSnsWrapper = () => {
  return (
    <div className={'ml-sns-wrapper'}>
      <div className={'ml-sns-box'}>
        <a
          href='https://www.facebook.com/mubeatTV'
          target={'_blank'}
          rel='noreferrer'
          className={'ml-sns-link'}
          aria-label={'Facebook'}
        >
          <i className={'icon icon-facebook'} />
        </a>
      </div>
      <div className={'ml-sns-box'}>
        <a
          href='https://twitter.com/MubeatOfficial'
          target={'_blank'}
          rel='noreferrer'
          className={'ml-sns-link'}
          aria-label={'Twitter'}
        >
          <i className={'icon icon-twitter'} />
        </a>
      </div>
      <div className={'ml-sns-box'}>
        <a
          href='https://www.instagram.com/mubeat_kpop/'
          target={'_blank'}
          rel='noreferrer'
          className={'ml-sns-link'}
          aria-label={'Instagram'}
        >
          <i className={'icon icon-instagram'} />
        </a>
      </div>
      <div className={'ml-sns-box'}>
        <a
          href='https://www.youtube.com/channel/UC--TqCe_AxlW6MNGHwBWhng'
          target={'_blank'}
          rel='noreferrer'
          className={'ml-sns-link'}
          aria-label={'Youtube'}
        >
          <i className={'icon icon-youtube'} />
        </a>
      </div>
      <div className={'ml-sns-box'}>
        <a href='mailto:support@mubeat.tv' className={'ml-sns-link'} aria-label={'Email'}>
          <i className={'icon icon-email'} />
        </a>
      </div>
    </div>
  );
};

export default MLSnsWrapper;
